import {MutationTree} from "vuex";
import {PaperclipWidgetState} from "@/apps/PaperclipWidget/models/paperclip-widget-state";

export default <MutationTree<PaperclipWidgetState>>{
    toggleCollapsed(state) {
        state.isCollapsed = !state.isCollapsed;

        // Persist the collapsed state in local storage
        localStorage.setItem(
            "paperclip-widget-isCollapsed",
            JSON.stringify(state.isCollapsed));
    }
}



